import "./PreviewWindowHeader.css";

/** Decorative desktop chrome for the illustrated camera preview. */
export function PreviewWindowHeader() {
  return (
    <div className="oc-preview-window-header">
      <span className="oc-preview-window-name">
        <svg
          className="oc-preview-window-camera"
          viewBox="0 0 16 16"
          fill="none"
          aria-hidden="true"
        >
          <rect x="1.5" y="4" width="9" height="8" rx="1.5" />
          <path d="m10.5 6 4-2v8l-4-2" />
          <circle cx="6" cy="8" r="1.7" />
        </svg>
        <span>ContCam</span>
      </span>

      <span className="oc-preview-window-caption">Effects preview</span>

      <span className="oc-preview-window-glyphs" aria-hidden="true">
        <svg viewBox="0 0 12 12" fill="none"><path d="M2 8.5h8" /></svg>
        <svg viewBox="0 0 12 12" fill="none"><path d="M2.5 2.5h7v7h-7z" /></svg>
        <svg viewBox="0 0 12 12" fill="none"><path d="m3 3 6 6m0-6L3 9" /></svg>
      </span>
    </div>
  );
}
